const { getElement } = window.BAO.Utils

export class ProductForm extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))

    this.onSelectChange = this.onSelectChange.bind(this)

    if (this.els?.select?.exists) {
      this.listeners.add(this.els.select.element, 'change', this.onSelectChange)
    }
  }

  async onSelectChange () {
    if (window.BAO.Tagalys?.handleProductCardFormChange) {
      window.BAO.Tagalys.handleProductCardFormChange(this.form)
    }

    await this.addToCart()
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    const isMultipack = getElement('[data-product-multipack]')
    if (isMultipack) return

    await this.addToCart()
  }

  async addToCart () {
    return window.BAO.Cart.addItemFromForm(this.form)
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
